
export const attendanceStudentRecordConstants = {
    GET_BY_SESSION_REQUEST: 'ATTENDANCE_STUDENT_RECORD_GET_BY_SESSION_REQUEST',
    GET_BY_SESSION_SUCCESS: 'ATTENDANCE_STUDENT_RECORD_GET_BY_SESSION_SUCCESS',
    GET_BY_SESSION_FAILURE: 'ATTENDANCE_STUDENT_RECORD_GET_BY_SESSION_FAILURE',
    
    GET_BY_MONTH_REQUEST: 'ATTENDANCE_STUDENT_RECORD_GET_BY_MONTH_REQUEST',
    GET_BY_MONTH_SUCCESS: 'ATTENDANCE_STUDENT_RECORD_GET_BY_MONTH_SUCCESS',
    GET_BY_MONTH_FAILURE: 'ATTENDANCE_STUDENT_RECORD_GET_BY_MONTH_FAILURE',

    GET_BY_MONTHS_AND_STUDENT_REQUEST: 'ATTENDANCE_STUDENT_RECORD_GET_BY_MONTH_AND_STUDENT_REQUEST',
    GET_BY_MONTHS_AND_STUDENT_SUCCESS: 'ATTENDANCE_STUDENT_RECORD_GET_BY_MONTH_AND_STUDENT_SUCCESS',
    GET_BY_MONTHS_AND_STUDENT_FAILURE: 'ATTENDANCE_STUDENT_RECORD_GET_BY_MONTH_AND_STUDENT_FAILURE',

    ADD_NEW_STUDENT_RECORDS_SUCCESS: 'ADD_NEW_STUDENT_RECORDS_SUCCESS',
    UPDATE_NEW_STUDENT_RECORDS_SUCCESS: 'UPDATE_NEW_STUDENT_RECORDS_SUCCESS',
};
